import { __extends } from "tslib";
import React, { Component } from 'react';
import MobileCta from '../../../../svgIcons/dist/components/mobileCta';
import { DEFAULT_HEADER_COLOR, DEFAULT_HEADER_TEXT_COLOR, } from '../../../../constants/default-widget-colors';
import _get from 'lodash/get';
import classNames from 'classnames';
import withTheme from '../../../../providers/theme/withTheme';
import { expandCollapseManager } from '../../../../services/expand-collapse-manager/expand-collapse-manager';
// @ts-ignore
import styles from './MobileCollapsedHeader.scss';
export default withTheme(/** @class */ (function (_super) {
    __extends(MobileCollapsedHeader, _super);
    function MobileCollapsedHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobileCollapsedHeader.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, shouldApplyCollapseAnimation = _b.shouldApplyCollapseAnimation, onlineTitle = _b.onlineTitle;
        var backgroundColor = _get(theme, 'header.background', DEFAULT_HEADER_COLOR);
        var headerTextColor = _get(theme, 'header.textColor', DEFAULT_HEADER_TEXT_COLOR);
        var headerStyle = { backgroundColor: backgroundColor, color: headerTextColor };
        var mobileCollapsedHeaderClasses = classNames((_a = {},
            _a[styles.wrapper] = true,
            _a[styles.shouldApplyCollapseAnimation] = shouldApplyCollapseAnimation,
            _a));
        return (React.createElement("div", { "data-hook": "mobile-collapsed-header", className: mobileCollapsedHeaderClasses, onClick: expandCollapseManager.expand, style: headerStyle },
            React.createElement("button", { className: styles.expandButton, "data-hook": "expand-button", "aria-label": onlineTitle },
                React.createElement(MobileCta, { size: "26px" }))));
    };
    return MobileCollapsedHeader;
}(Component)));
//# sourceMappingURL=MobileCollapsedHeader.js.map